import { render } from "./PrepareReceptionModal.vue?vue&type=template&id=2f31220e"
import script from "./PrepareReceptionModal.vue?vue&type=script&lang=js"
export * from "./PrepareReceptionModal.vue?vue&type=script&lang=js"

import "./PrepareReceptionModal.vue?vue&type=style&index=0&id=2f31220e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__